import { IPanel, LinkActionSchema } from "smarthub-common";

export const chatPanel: IPanel = {
  $id: "panel.chat",
  $schema: "https://ics.ai/smarthub/panel",
  group: "panels.intranet",
  description: "Chat transcript and controls",
  title: "Chat",
  shortTitle: "chat",
  icon: {
    name: "Chat",
  },
  order: 1,
  initialFocus: "chat-controls",
  navigation: "none",
  menu: {
    $id: "component.chat-menu",
    $schema: "https://ics.ai/smarthub/component",
    template: "component.chat-menu",
    title: "Chat menu",
    description: "Choose display settings",
    props: {
      showLauncher: false,
    },
  },
  pages: {
    $id: "component.chat-pages",
    $schema: "https://ics.ai/smarthub/component",
    template: "component.chat-pages",
    title: "Chat pages",
    description: "Chat pages",
    props: {
      config: {
        pages: [
          {
            id: "test",
            fullWidth: false,
            sections: [
              {
                type: "heading",
                config: {
                  text: "Heading 1",
                  size: "h1",
                },
              },
              {
                type: "form",
                config: {
                  definition: [
                    {
                      id: "name",
                      label: "Account Name",
                      type: "text",
                      placeholder: "Please enter name",
                    },
                    {
                      id: "notes",
                      label: "Notes",
                      type: "textarea",
                      placeholder: "Please enter note",
                    },
                    {
                      id: "enabled",
                      label: "Enabled",
                      type: "checkbox",
                      placeholder: "Please enter note",
                    },
                    {
                      id: "type",
                      label: "Type",
                      type: "choice",
                      placeholder: "Please select",
                      values: [
                        {
                          value: "PRIMARY",
                          text: "Primary",
                        },
                        {
                          value: "EXTERNAL",
                          text: "External",
                        },
                      ],
                    },
                    {
                      id: "coords",
                      label: "Coordinates",
                      type: "number",
                      validation: {
                        required: "Coordinates is required",
                      },
                    },
                  ],
                  data: {
                    name: "",
                  },
                  action: {
                    url: "https://enheuj6t0mlbd.x.pipedream.net",
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                    },
                  },
                  insertMode: true,
                  autoSave: false,
                },
              },
            ],
          },
          {
            id: "about",
            title: "About",
            fullWidth: true,
            sections: [
              {
                type: "html",
                config: {
                  html: "<p>Welcome to Westershire, a prestigious higher education university located in the heart of the bustling city. Founded in 1878, Westershire has been committed to providing top-notch education and training to students from all over the world. With a diverse student body, cutting-edge facilities, and renowned faculty, Westershire is the perfect place to embark on your academic journey.</p><img src='https://www.travelandleisure.com/thmb/E5szi7N2r1eN-8b3vkl5STvWz9o=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/notre-dame-university-COLLEGECAMP0421-039ce0bfd40b4e429b825c6fb6ebfaa6.jpg' style='margin-bottom:10px;'/><p>At Westershire, we believe that education should be a transformative experience that goes beyond the classroom. That's why we offer a wide range of programs and resources to help our students explore their interests, develop their skills, and prepare for successful careers. From internships and research opportunities to community service and leadership development programs, we are committed to providing our students with the tools they need to succeed in today's rapidly changing world.</p><p>Whether you're interested in the arts, sciences, business, or technology, Westershire has something for everyone. Come explore our beautiful campus, meet our friendly and supportive community, and discover why Westershire is the perfect place to pursue your dreams.</p>",
                },
              },
            ],
          },
          {
            id: "privacy",
            title: "Privacy",
            sections: [
              {
                type: "html",
                config: {
                  html: "<p><strong>Morbi in tincidunt nunc.</strong> Donec sit amet lorem quis odio volutpat facilisis. Sed ultricies nisi odio, vel iaculis lacus tincidunt in. Aliquam velit turpis, mollis eu ipsum ut, efficitur dictum diam. Nulla vitae vehicula ipsum, quis molestie urna. Cras quis sapien arcu. Praesent ligula lectus, euismod sed diam non, tempus sollicitudin neque.</p><p> Vivamus scelerisque est in dui scelerisque, quis faucibus ligula molestie. Cras fermentum eget nunc eget aliquet. Nullam vel ultrices elit.</p>",
                },
              },
            ],
          },
        ],
      },
    },
  },
  launcher: {
    $id: "component.chat-launcher",
    $schema: "https://ics.ai/smarthub/component",
    template: "component.chat-launcher",
    title: "Chat launcher",
    description: "Chat launcher",
    props: {
      enabled: false,
      config: {
        title: {
          en: "Learn with Copilot, your virtual teaching assistant",
        },
        subtitle: {
          en: "Accelerate your learning with Coilot, your virtual teaching assistant guiding you through your learning journey",
        },
        sections: [
          {
            id: "dd9d38e9-68ec-4559-bee5-300f543d37fc",
            title: {
              en: "Test",
            },
            subtitle: {
              en: "Test",
            },
            children: [
              {
                id: "14b05bf9-3885-4d99-bae6-753d7d88fb9a",
                type: "Button",
                config: {
                  actions: [
                    {
                      action: "Page",
                      pageId: "about",
                    },
                  ],
                  title: {
                    en: "About",
                  },
                  subtitle: {
                    en: "About Page",
                  },
                  imageUrl:
                    'data:image/svg+xml;utf8,<svg fill="white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--! Font Awesome Free 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"/></svg>',
                },
              },
              {
                id: "14b05bf9-3885-4d99-bae6-753d7d88fb9a",
                type: "Button",
                config: {
                  actions: [
                    {
                      action: "Page",
                      pageId: "test",
                    },
                  ],
                  title: {
                    en: "Test",
                  },
                  subtitle: {
                    en: "Test Page",
                  },
                  imageUrl:
                    'data:image/svg+xml;utf8,<svg fill="white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--! Font Awesome Free 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"/></svg>',
                },
              },
            ],
          },

          {
            title: {
              en: "Your AI Teaching Assistants",
            },
            subtitle: {
              en: "Select your AI Teaching Assistants to access specific content and information about them.",
            },
            children: [
              {
                id: "bfa45931-e984-442e-9388-d936f0dfa4e0",
                type: "Button",
                config: {
                  actions: [
                    {
                      action: "Personality",
                      payload: {
                        personality: "fiona",
                      },
                    },
                  ],
                  title: {
                    en: "Fiona",
                  },
                  subtitle: {
                    en: "Business School",
                  },
                  imageUrl:
                    'data:image/svg+xml;utf8,<svg fill="white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--! Font Awesome Free 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"/></svg>',
                },
              },
              {
                id: "d86f23b2-5421-4dd0-9da3-50ac1b6f7ef1",
                type: "Button",
                config: {
                  actions: [
                    {
                      action: "Personality",
                      payload: {
                        personality: "holly",
                      },
                    },
                  ],
                  title: {
                    en: "Holly",
                  },
                  subtitle: {
                    en: "Social Sciences",
                  },
                  imageUrl:
                    'data:image/svg+xml;utf8,<svg fill="white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--! Font Awesome Free 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"/></svg>',
                },
              },
              {
                id: "4e6b79fa-488c-442f-97be-d3de97696e3a",
                type: "Button",
                config: {
                  actions: [
                    {
                      action: "Personality",
                      payload: {
                        personality: "Cathy",
                      },
                    },
                  ],
                  title: {
                    en: "Cathy",
                  },
                  subtitle: {
                    en: "Student Services",
                  },
                  imageUrl:
                    'data:image/svg+xml;utf8,<svg fill="white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--! Font Awesome Free 6.4.0 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2023 Fonticons, Inc. --><path d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"/></svg>',
                },
              },
            ],
          },
        ],
      },
    },
  },
  splash: {
    $id: "component.chat-splash",
    $schema: "https://ics.ai/smarthub/component",
    title: "Chat splash",
    description: "Chat splash",
    template: "component.chat-splash",
    props: {
      enabled: true,
      mode: "implicit",
      cacheLocation: "session",
      version: "1.0",
      sessionKey: "customer.ai-flex-chat-tnc-acceptance",
      config: {
        html: {
          en: "<p>Hi, I'm WelChat, Welwyn Hatfield's Council's digital helper. I'm here to help you with any questions you have about our services.</p><p>To get the best answers, please phrase your questions in a sentence using four words or more.</p><p>If you don't get the answer you're looking for, try typing your question a different way.</p><p>I'm always learning, so please let me know about your experience by leaving a comment in the 'rate my result' box.  Your feedback will help me improve your future experience.</p><p>Find out more about me on our website: <b><u><a href='https://www.welhat.gov.uk' target='_blank'>https://www.welhat.gov.uk</a></u></b></p><p>To start chatting, choose 'Continue' below to confirm you have read and understood our <b><u><a href='https://www.welhat.gov.uk/policies/privacy-notice' target='_blank'>privacy policy.</a></u></b></p>",
        },

        container: {
          margin: "0px",
          padding: "20px",
          backgroundColor: "#fff",
          textColor: "#333",
          fontSize: "18px",
        },
        buttons: {
          primaryButtonBackgroundColor: "#005dc4",
          primaryButtonHoverBackgroundColor: "#333",
          primaryButtonTextColor: "white",
          primaryButtonHoverTextColor: "white",
          primaryButtonPadding: "20px",
          primaryButtonFontSize: "18px",
          secondaryButtonBackgroundColor: "white",
          secondaryButtonHoverBackgroundColor: "white",
          secondaryButtonTextColor: "black",
          secondaryButtonHoverTextColor: "black",
          secondaryButtonPadding: "20px",
          secondaryButtonFontSize: "18px",
        },
      },
    },
  },
  header: {
    $id: "component.chat-header",
    $schema: "https://ics.ai/smarthub/component",
    title: "Chat header",
    description: "Chat header",
    template: "component.chat-header",
  },
  footer: {
    $id: "component.chat-footer",
    $schema: "https://ics.ai/smarthub/component",
    title: "Chat footer",
    description: "Chat footer",
    template: "component.chat-footer",
    props: {
      actions: [
        {
          name: {
            en: "privacy",
          },
          title: "",
          shortTitle: {
            en: "Privacy Statement",
          },
          description: "",
          action: {
            $id: "",
            $schema: LinkActionSchema,
            uri: "https://pentesting-prod.icshosting.net/privacy/",
            target: "_self",
          },
        },
      ],
    },
  },
  templates: [
    {
      $id: "template.chat",
      $schema: "https://ics.ai/smarthub/template",
      description: "Felix chat transcript and controls",
      title: "Felix chat",
      shortTitle: "Chat",
      group: "templates.intranet",
      tabs: [
        {
          $id: "layout.chat",
          $schema: "https://ics.ai/smarthub/tab",
          description: "Felix chat transcript and controls.",
          group: "tabs.intranet",
          title: "Chat",
          shortTitle: "Chat",
          icon: {
            name: "Chat",
          },
          body: {
            grid: {
              tokens: {
                padding: "none",
              },
              rows: [
                {
                  responsive: {
                    sm: { scroll: true, stretch: true },
                  },
                  columns: [
                    {
                      responsive: {
                        sm: { size: 12, fill: true },
                      },
                      zones: [
                        {
                          id: "zone.main",
                        },
                      ],
                    },
                  ],
                },
                {
                  columns: [
                    {
                      responsive: {
                        sm: { size: 12, fill: true },
                      },
                      zones: [
                        {
                          id: "zone.controls",
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            zones: [
              {
                id: "zone.main",
                components: [
                  {
                    $id: "component.chat-transcript",
                    $schema: "https://ics.ai/smarthub/component",
                    title: "Chat transcript",
                    description: "Chat conversation",
                    template: "component.chat-transcript",
                  },
                ],
              },
              {
                id: "zone.controls",
                components: [
                  {
                    $id: "component.chat-controls",
                    $schema: "https://ics.ai/smarthub/component",
                    title: "Chat transcript",
                    description: "Chat controls",
                    template: "component.chat-controls",
                  },
                ],
              },
            ],
          },
        },
      ],
    },
  ],
};
